// extracted by mini-css-extract-plugin
export var label = "_ae-1";
export var reminder = "_ae-0";